import {useTranslation} from "react-i18next";

function QuestionGrid({ sim, setSim, goToQuestion, toggleGrid }) {
    const { t, i18n } = useTranslation();
    return (
        <div className="exam-sim-question-grid" style={{ display: sim.gridVisible ? 'block' : 'none'}}>
            <ul className="exam-sim-question-grid-items">
                {sim.currentQuestions.map((q, idx) => {
                    let classes = []
                    if(q.marked)
                        classes.push('marked')
                    if(idx === sim.currentQuestion)
                        classes.push('current')
                    if(q.answer === null || q.answer?.length === 0)
                        classes.push('missing')
                    if(!sim.timeRunning)
                        classes.push('disabled')

                    return <li key={idx} className={classes.join(' ')}>
                        <button type="button" onClick={() => goToQuestion(idx)}>{idx + 1}</button>
                    </li>
                })}
            </ul>
            <div>
                <button type="button" className="btn" onClick={toggleGrid}>{t('button.back')}</button>
            </div>
        </div>
    );
}

export default QuestionGrid;
